"use client";
import type { ReactElement } from "react";
import { motion, type MotionValue } from "framer-motion";
import { PERIOD_WASH_WIDTH } from "./timeline-constants";
export interface TimelinePeriodWashProps {
    trackY: number;
    washGradient: string;
    washHeight: number;
    washOpacity: MotionValue<number>;
}
export function TimelinePeriodWash({ trackY, washGradient, washHeight, washOpacity, }: TimelinePeriodWashProps): ReactElement {
    return (
    <motion.div style={{
            position: "absolute",
            left: "50%",
            top: trackY - washHeight / 2,
            width: PERIOD_WASH_WIDTH,
            height: washHeight,
            marginLeft: -PERIOD_WASH_WIDTH / 2,
            backgroundImage: washGradient,
            opacity: washOpacity,
            pointerEvents: "none",
            zIndex: 0,
        }}/>
    );
}
